import React from "react";
import { FaEnvelope, FaHeadset } from "react-icons/fa";

const SUPPORT_EMAIL = "support@tumma.co";

function TenantSupport() {
  return (
    <div className="cportal-page">
      <div className="cportal-page-head">
        <div>
          <h1>Support</h1>
          <p className="cportal-muted">Get help with your Cloud Connect workspace.</p>
        </div>
      </div>

      <div className="cportal-support-card">
        <div className="cportal-support-card-head">
          <div className="cportal-support-card-icon" aria-hidden="true">
            <FaHeadset />
          </div>
          <h2>Contact Support</h2>
        </div>
        <p>
          Reach our team for account access, billing questions, or product help.
          We typically respond within one business day.
        </p>
        <div className="cportal-support-contacts">
          <a className="cportal-support-contact" href={`mailto:${SUPPORT_EMAIL}`}>
            <FaEnvelope aria-hidden="true" />
            <span>{SUPPORT_EMAIL}</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default TenantSupport;
